__turbopack_context__.v({
  "Container": "v5PcUW_Container",
  "HelperText": "v5PcUW_HelperText",
  "Label": "v5PcUW_Label",
  "Switch": "v5PcUW_Switch",
  "SwitchWrap": "v5PcUW_SwitchWrap",
  "TextContent": "v5PcUW_TextContent",
  "Thumb": "v5PcUW_Thumb",
  "checkIcon": "v5PcUW_checkIcon",
  "closeIcon": "v5PcUW_closeIcon",
  "disabled": "v5PcUW_disabled",
  "dot": "v5PcUW_dot",
  "root": "v5PcUW_root",
  "secondary": "v5PcUW_secondary",
  "switch": "v5PcUW_switch",
  "thumb": "v5PcUW_thumb",
});
